__turbopack_context__.v({
  "arrow": "journey-timeline-module__3gCrIW__arrow",
  "badgeWithYear": "journey-timeline-module__3gCrIW__badgeWithYear",
  "badgesRow": "journey-timeline-module__3gCrIW__badgesRow",
  "circularBadge": "journey-timeline-module__3gCrIW__circularBadge",
  "container": "journey-timeline-module__3gCrIW__container",
  "event": "journey-timeline-module__3gCrIW__event",
  "eventArrow": "journey-timeline-module__3gCrIW__eventArrow",
  "eventsRow": "journey-timeline-module__3gCrIW__eventsRow",
  "futureOverlay": "journey-timeline-module__3gCrIW__futureOverlay",
  "futureZone": "journey-timeline-module__3gCrIW__futureZone",
  "header": "journey-timeline-module__3gCrIW__header",
  "intro": "journey-timeline-module__3gCrIW__intro",
  "keoLogo": "journey-timeline-module__3gCrIW__keoLogo",
  "outerContainer": "journey-timeline-module__3gCrIW__outerContainer",
  "paragraph": "journey-timeline-module__3gCrIW__paragraph",
  "paragraphs": "journey-timeline-module__3gCrIW__paragraphs",
  "section": "journey-timeline-module__3gCrIW__section",
  "soldLabel": "journey-timeline-module__3gCrIW__soldLabel",
  "subtitle": "journey-timeline-module__3gCrIW__subtitle",
  "timelineBar": "journey-timeline-module__3gCrIW__timelineBar",
  "timelineWrapper": "journey-timeline-module__3gCrIW__timelineWrapper",
  "yearLabel": "journey-timeline-module__3gCrIW__yearLabel",
});
